import React from "react";
import ConfirmDialog from "../custom-dialog/confirm-dialog";
import AddOrderDialogMain from "../AddOrderDialogMain";
import InvoiceModal from "../InvoiceModal";
import { Button } from "@mui/material";

const OrderDialogs = ({
  openConfirmDialog,
  handleCloseConfirmDialog,
  dialogActionType,
  handleConfirmAction,
  isAddOrderDialogOpen,
  setIsAddOrderDialogOpen,
  handleOrderAdded,
  showInvoiceModal,
  handleCloseInvoiceModal,
  selectedOrderForInvoice,
}) => {
  return (
    <>
      <ConfirmDialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        title={
          dialogActionType === "cancel"
            ? "Xác nhận hủy đơn hàng"
            : "Xác nhận xóa đơn hàng"
        }
        content={
          dialogActionType === "cancel"
            ? "Bạn có chắc chắn muốn hủy đơn hàng này? Hành động này sẽ không thể hoàn tác."
            : "Bạn có chắc chắn muốn xóa đơn hàng này? Hành động này sẽ không thể hoàn tác và số lượng sản phẩm sẽ được khôi phục."
        }
        action={
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirmAction}
          >
            Đồng ý
          </Button>
        }
      />
      <AddOrderDialogMain
        open={isAddOrderDialogOpen}
        onClose={() => setIsAddOrderDialogOpen(false)}
        onOrderAdded={handleOrderAdded}
      />
      <InvoiceModal
        show={showInvoiceModal}
        handleClose={handleCloseInvoiceModal}
        order={selectedOrderForInvoice}
      />
    </>
  );
};

export default OrderDialogs;
